'use client';

import AdPlaceholder from './AdPlaceholder';

interface SidebarAdProps {
  slot: string;
  className?: string;
}

const SidebarAd: React.FC<SidebarAdProps> = ({ slot, className = '' }) => {
  return (
    <div className={`sticky top-4 ${className}`}>
      <AdPlaceholder
        slot={slot}
        format="vertical"
        style={{ minHeight: '600px', maxWidth: '300px' }}
      />
    </div>
  );
};

export default SidebarAd;